import React from 'react'
import injectSheet from 'react-jss'
import { OptionGroupElements } from '../../'

const OfferLayout = (props) => {
  const {
    classes,
    houseTypeSelection: { layout },
  } = props

  return (
    <div className={`${classes.container}`}>
      <OptionGroupElements
        node={layout}
      />
    </div>
  )
}

const styles = theme => ({
  container: {
    borderBottom: `2px solid ${theme.colors.secondary_3a}`,
  },
})


export default injectSheet(styles)(OfferLayout)



// WEBPACK FOOTER //
// ./src/modules/offer/components/offerLayout.jsx